// extracted by mini-css-extract-plugin
module.exports = {"checkout-button-container":"checkout-button_checkout-button-container__nyk2B","checkout-button-terms":"checkout-button_checkout-button-terms__RID37"};